import { Component, OnInit } from '@angular/core';
import { TenderingService } from 'src/app/services/tendering/tendering.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-submittedquote',
  templateUrl: './submittedquote.component.html',
  styleUrls: ['./submittedquote.component.css']
})
export class SubmittedquoteComponent implements OnInit {
data:any;
  constructor(private tenderingservices:TenderingService, private router:Router,
    private route:ActivatedRoute) { }

  ngOnInit() {
  }
  getEnquiryList() {
    this.tenderingservices.GetSubmittedQuotes().subscribe(
      data => {
        this.data = data;
        console.log(this.data);
      }
    )
  }
  sendTechQuote= function (id) {
    //alert(id);
    this.router.navigate(['/submittechquote/' + id + '']);
  }
  sendPriceQuote= function (id) {
    this.router.navigate(['/submitpricequote/' + id + '']);
  }
  sendBoth = function (id) {
    //alert(id);
    this.router.navigate(['/submitpriceandtechquote/' + id + '']);
  }
  smtvendqoutesearch(keyword){
    this.tenderingservices.SmtVendQuoteSearch(keyword).subscribe(
      (data)=>{
        this.data=data;
        console.log(data);
      }
    )

  }

}
